import React from 'react';
import { StyledChatPage } from './ChatPage.styled';
import { CirclesBackground } from '../styleElements/CirclesBackground';

export const ChatPage = () => {
  return (
    <StyledChatPage>
      <CirclesBackground />
      Coming Soon
    </StyledChatPage>
  );
};
